/* Predictive search for the Yatas header.
 *
 * The header search was rebuilt to match the reference and is a plain GET
 * form, so it only ever navigated to /search on Enter - no suggestions. This
 * wires it to Shopify's predictive search endpoint and renders a dropdown.
 *
 * Everything is delegated from document rather than bound per form at load:
 * the header is a custom element and re-renders, which silently discarded
 * listeners bound at init time. Delegation survives that, and the panel is
 * created lazily on first keystroke.
 */
(function () {
  'use strict';

  // Proof-of-execution marker, so it is possible to tell "script never ran"
  // apart from "script ran but found nothing".
  document.documentElement.setAttribute('data-ybn-search', 'ready');

  var SEL = '.ybn-search input[name="q"], .ybn-mm__mb-search input[name="q"]';
  var MIN_CHARS = 2;
  var DEBOUNCE_MS = 250;
  var LIMIT = 6;

  var timer = null;
  var controller = null;

  function esc(s) {
    return String(s == null ? '' : s).replace(/[&<>"']/g, function (c) {
      return { '&': '&amp;', '<': '&lt;', '>': '&gt;', '"': '&quot;', "'": '&#39;' }[c];
    });
  }

  // The endpoint returns a decimal string ("733.55"), not cents.
  function money(v) {
    if (v == null || v === '') return '';
    var n = parseFloat(v);
    if (isNaN(n)) return '';
    return '€' + n.toFixed(2).replace('.', ',');
  }

  function thumb(url) {
    if (!url) return '';
    return url.indexOf('?') === -1 ? url + '?width=120' : url + '&width=120';
  }

  function panelFor(input) {
    var form = input.closest('form');
    if (!form) return null;
    var panel = form.querySelector('.ybn-sugg');
    if (!panel) {
      panel = document.createElement('div');
      panel.className = 'ybn-sugg';
      panel.hidden = true;
      panel.setAttribute('role', 'listbox');
      form.appendChild(panel);
      form.classList.add('ybn-search--live');
    }
    return panel;
  }

  function close(panel) {
    if (panel) panel.hidden = true;
  }

  function items(panel) {
    return Array.prototype.slice.call(panel.querySelectorAll('.ybn-sugg__item'));
  }

  function render(panel, products, query) {
    var all = '/search?q=' + encodeURIComponent(query) + '&type=product';

    if (!products.length) {
      panel.innerHTML =
        '<p class="ybn-sugg__empty">Geen resultaten gevonden voor &ldquo;' +
        esc(query) + '&rdquo;</p>';
      panel.hidden = false;
      return;
    }

    var html = '<ul class="ybn-sugg__list">';
    products.forEach(function (p) {
      html +=
        '<li><a class="ybn-sugg__item" href="' + esc(p.url) + '" role="option">' +
        (p.featured_image && p.featured_image.url
          ? '<img class="ybn-sugg__img" src="' + esc(thumb(p.featured_image.url)) +
            '" alt="" loading="lazy" width="56" height="56">'
          : '<span class="ybn-sugg__img"></span>') +
        '<span class="ybn-sugg__body">' +
        '<span class="ybn-sugg__title">' + esc(p.title) + '</span>' +
        (money(p.price) ? '<span class="ybn-sugg__price">' + money(p.price) + '</span>' : '') +
        '</span></a></li>';
    });
    html += '</ul>';
    html +=
      '<a class="ybn-sugg__all" href="' + esc(all) + '">Alle resultaten voor &ldquo;' +
      esc(query) + '&rdquo;</a>';

    panel.innerHTML = html;
    panel.hidden = false;
  }

  function lookup(input) {
    var q = input.value.trim();
    var panel = panelFor(input);
    if (!panel) return;
    if (q.length < MIN_CHARS) { close(panel); return; }

    if (controller) controller.abort();
    controller = typeof AbortController !== 'undefined' ? new AbortController() : null;

    var url =
      '/search/suggest.json?q=' + encodeURIComponent(q) +
      '&resources[type]=product&resources[limit]=' + LIMIT;

    fetch(url, controller ? { signal: controller.signal } : undefined)
      .then(function (r) { return r.ok ? r.json() : null; })
      .then(function (data) {
        if (!data) return;
        var list =
          (data.resources && data.resources.results && data.resources.results.products) || [];
        // A slow reply for an older query must not overwrite a newer one.
        if (input.value.trim() !== q) return;
        render(panel, list, q);
      })
      .catch(function () { /* aborted or offline - leave the panel alone */ });
  }

  document.addEventListener('input', function (e) {
    var input = e.target;
    if (!input || !input.matches || !input.matches(SEL)) return;
    clearTimeout(timer);
    var q = input.value.trim();
    if (q.length < MIN_CHARS) { close(panelFor(input)); return; }
    timer = setTimeout(function () { lookup(input); }, DEBOUNCE_MS);
  });

  document.addEventListener('keydown', function (e) {
    var input = e.target;
    if (!input || !input.matches || !input.matches(SEL)) return;
    var panel = panelFor(input);
    if (!panel) return;

    if (e.key === 'Escape') { close(panel); return; }
    if (panel.hidden) return;

    var list = items(panel);
    if (!list.length) return;

    var active = list.findIndex(function (el) { return el.classList.contains('is-active'); });

    if (e.key === 'ArrowDown' || e.key === 'ArrowUp') {
      e.preventDefault();
      var next = e.key === 'ArrowDown'
        ? (active + 1 >= list.length ? 0 : active + 1)
        : (active - 1 < 0 ? list.length - 1 : active - 1);
      list.forEach(function (el, n) { el.classList.toggle('is-active', n === next); });
    } else if (e.key === 'Enter' && active > -1) {
      e.preventDefault();
      window.location.href = list[active].getAttribute('href');
    }
  });

  document.addEventListener('click', function (e) {
    document.querySelectorAll('.ybn-sugg').forEach(function (panel) {
      var form = panel.closest('form');
      if (form && !form.contains(e.target)) panel.hidden = true;
    });
  });
})();
